import { ProgressSpinnerDesignTokens } from '@primeuix/themes/aura/progressspinner';

export const progressSpinnerTokens: ProgressSpinnerDesignTokens = {
  colorScheme: {
    light: {
      root: {
        colorOne: '{primary.500}',
        colorTwo: '{primary.500}',
        colorThree: '{primary.500}',
        colorFour: '{primary.500}',
      },
    },
    dark: {
      root: {
        colorOne: '{primary.300}',
        colorTwo: '{primary.300}',
        colorThree: '{primary.300}',
        colorFour: '{primary.300}',
      },
    },
  },
};
